const LIMIT_LEAVE_DAYS = 'limit-day-leave';
const LIMIT_WFH_DAYS = 'limit-day-wfh';

export { LIMIT_LEAVE_DAYS, LIMIT_WFH_DAYS };
